// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rRACupm6rmIDcg {\n  display: flex;\n  margin: 8px 0 12px;\n}\n.rRACupm6rmIDcg input {\n  flex-grow: 1;\n  margin: 0;\n  width: 0;\n}\n.rRACupm6rmIDcg input:focus {\n  background: #ffffff;\n  border: none;\n  box-shadow: inset 0 0 0 2px #0079BF;\n}\n.rRACupm6rmIDcg button {\n  height: 32px;\n  margin: 0;\n  margin-left: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shareLinkContainer": "rRACupm6rmIDcg"
};
export default ___CSS_LOADER_EXPORT___;
